/*
https://developers.facebook.com/tools/debug/

https://www.asspm.fr/app/?u=news/stage-u-11-u-13
*/

import axios from 'axios';

const FB_APP_ID = process.env.VUE_APP_FB_APP_ID
const HOST = process.env.VUE_APP_HOST

class MetaService {

  static post() {
    const meta = Array.from(document.querySelectorAll('meta')).map(m => m.outerHTML).join("")
    const hash = window.location.search.replace("?u=", '')

    var fd = new FormData();
    fd.append("meta", meta);
    fd.append("u", hash);

    // console.log("MetaService", "post", "exit before update")
    // return

    console.log("MetaService", "post")

    axios.post(HOST + "/app/index.php", fd, {
      headers: {'Content-Type': 'application/x-www-form-urlencoded'}
    })
  }

  static info(info) {
    if (_.isNil(info.title)) return;
    if (!info.url) {
      //debugger
      info.url = HOST + "/app/?u=" + window.location.hash.replace("#/", "");
    }
    _.delay(() => MetaService.post(), 1000);
    return {
      title: "",
      titleTemplate: info.title,
      meta: [
        //{property: "fb:app_id", content: "2473481466216139"},
        {property: "fb:app_id", content: FB_APP_ID},
        /*
        Erreurs critiques devant être corrigées
        Could Not Follow Redirect Path	Using data from https://www.asspm.fr/app/?hash=bleuets-u-11-u-13-tournoi-a-longeville-sur-mer because there was an error following the redirect path.
        Warning
        Erreurs devant être corrigées
        Circular Redirect Path	Circular redirect path detected (see 'Redirect Path' section for details).
        Impossible de suivre la redirection.	L’URL a demandé une redirection HTTP, mais elle ne pouvait pas être suivie.
        */
        {property: "og:url", content: info.url},
        {property: "og:title", content: info.title},
        {property: "og:description", content: info.description},
        {property: "og:image", content: info.image},
        {property: "og:type", content: "article"},
        {property: "og:site_name", content: "asspm"},

        {property: "twitter:title", content: info.title},
        {property: "twitter:description", content: info.description},
        {property: "twitter:image", content: info.image},
        {property: "twitter:card", content: "summary_large_image"},
        {property: "twitter:site", content: "asspm"},
      ],
      htmlAttrs: {
        lang: 'fr',
        amp: true
      }
    }
  }
}

export default MetaService

export {MetaService}